import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoTrophy } from 'react-icons/io5';
import { HiPlay, HiLocationMarker, HiClock } from 'react-icons/hi';
import Header from '../components/Header';
import './BrandOption1.css';

export default function BrandOption1({ config }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    try {
      const res = await fetch(`${config.apiUrl}/games`);
      const data = await res.json();
      setGames(data.data.games || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const liveGames = games.filter(g => g.status === 'live');
  const upcomingGames = games.filter(g => g.status === 'scheduled' || g.status === 'ready');
  const recordedGames = games.filter(g => g.status === 'recorded' && g.recordingUrl);

  const logo = <IoTrophy className="header-logo-icon" />;

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="brand1">
      <Header logo={logo} brandName="APEX SPORTS" theme="dark" />
      
      <main className="main-content">
        <section className="hero-section">
          <h1>WHERE CHAMPIONS RISE</h1>
          <p>Premium youth sports streaming</p>
        </section>

        {liveGames.length > 0 && (
          <section className="games-section">
            <h2>LIVE NOW</h2>
            <div className="games-grid">
              {liveGames.map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card live">
                  <div className="card-badge">LIVE</div>
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <button className="watch-btn">
                    <HiPlay /> WATCH
                  </button>
                </Link>
              ))}
            </div>
          </section>
        )}

        {upcomingGames.length > 0 && (
          <section className="games-section">
            <h2>UPCOMING</h2>
            <div className="games-grid">
              {upcomingGames.slice(0, 6).map(game => (
                <div key={game.gameId} className="game-card">
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <div className="card-info">
                    <HiClock /> {new Date(game.scheduledStart).toLocaleString('en-US', { 
                      month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' 
                    })}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {recordedGames.length > 0 && (
          <section className="games-section">
            <h2>REPLAYS</h2>
            <div className="games-grid">
              {recordedGames.slice(0, 6).map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card replay-card">
                  {game.thumbnailUrl && (
                    <div className="replay-thumbnail">
                      <img src={game.thumbnailUrl} alt="Match" />
                      <div className="thumbnail-overlay">
                        <HiPlay className="play-icon-large" />
                      </div>
                    </div>
                  )}
                  <div className="replay-content">
                    <div className="card-badge">REPLAY</div>
                    <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                    <div className="card-info">
                      <HiLocationMarker /> {game.venue}
                    </div>
                    <button className="watch-btn">
                      <HiPlay /> WATCH
                    </button>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
